import React, { useState, useEffect } from "react";

const EMPRESA = {
  nombre: "LIBERTI CLUB IA, S.L.",
  cif: "B-00000000",
  dir: "Calle Ejemplo 1, 28001 Madrid, España",
  email: "hola@liberticlubia.com",
  reg: "Registro Mercantil de Madrid",
};

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("lci_cookies")) setVisible(true);
  }, []);
  const decide = (val) => { localStorage.setItem("lci_cookies", val); setVisible(false); };
  if (!visible) return null;
  return (
    <div data-testid="cookie-banner" style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 200,
      background: "rgba(13,13,20,.97)", borderTop: "1px solid var(--line)", backdropFilter: "blur(12px)",
      padding: "18px clamp(16px,5vw,48px)", display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap", justifyContent: "space-between",
    }}>
      <p style={{ color: "var(--muted)", fontSize: 13, fontWeight: 300, maxWidth: 640, lineHeight: 1.6 }}>
        Usamos cookies propias y de terceros para el funcionamiento de la plataforma y analítica. Puedes aceptarlas todas
        o rechazar las no esenciales. Más info en nuestra <a href="/legal/cookies" style={{ color: "var(--gold)" }}>Política de cookies</a>.
      </p>
      <div style={{ display: "flex", gap: 10 }}>
        <button className="btn btn-ghost btn-sm" data-testid="cookie-reject" onClick={() => decide("essential")}>Solo esenciales</button>
        <button className="btn btn-gold btn-sm" data-testid="cookie-accept" onClick={() => decide("all")}>Aceptar todas</button>
      </div>
    </div>
  );
}

export { EMPRESA };
